import {
  Box,
  CircularProgress,
  Container,
  Grid,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { CancelButton, SubmitButton } from "../components-atoms";
import {
  ErrorModal,
  GeneralModal,
  InfoBox,
  InfoLine,
} from "../components-molecules";
import { HttpRegularPost, HttpRegularPut } from "../service";
import { is_able_to, roleName } from "../utils/roles";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import CssBaseline from "@material-ui/core/CssBaseline";
import { ITheme } from "../constants/theme";
import { PhotoCameraOutlined } from "@material-ui/icons";
import {
  clearAccountDetails,
  getAccountDetails,
} from "../redux/actions/accountDetails";
import { useHistory } from "react-router-dom";
import { addressStringConvertor } from "../utils/addressStringConvertor";
import { HeaderWithButtonsResponsive } from "../components-molecules/HeaderWithButtonsResponsive";

// import { setError } from "../redux/actions/error";
const Platforms = ["Instagram", "Facebook", "Linkedin", "Twitter", "Youtube"];

interface ShopFormI {
  Name?: string;
  Line1?: string;
  Line2?: string;
  PostalCode?: string;
  City?: string;
  County?: string;
}
const imageTypes: string[] = ["png", "jpg", "jpeg"];

export const AccountSettings = (props: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  //const [logo, setLogo] = useState<any>();
  const [merchantName, setMerchantName] = useState("");
  const [slogan, setSlogan] = useState("");
  const [brandColour, setBrandColour] = useState("");
  const [address, setAddress] = useState<ShopFormI>({});
  const [returnsWindow, setReturnsWindow] = useState<Number | null>(0);
  const [socialMedia, setSocialMedia] = useState<Array<{
    Platform?: string;
    Link?: string;
  }> | null>();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [editType, setEditType] = useState("");
  const [imageLoading, setImageLoading] = useState(false);
  useEffect(() => {
    roleName() === "Merchant" && dispatch(getAccountDetails());
    return () => {
      dispatch(clearAccountDetails());
    };
  }, []); // eslint-disable-line
  const data = useSelector((state: any) => state.accountDetails.data);
  const [errorModalOpen, setErrorModalOpen] = useState<boolean>(false);
  // useEffect(() => {
  //   data?.MerchantSocialMediaLinks &&
  //     setSocialMedia([...data?.MerchantSocialMediaLinks]);
  // }, [data]);
  const handleAddressChange =
    (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setAddress({
        ...address,
        [field]: event.target.value,
      });
    };

  const handleSocialMediaEdit = (platformType: string) => (event: any) => {
    const sm = socialMedia ? [...socialMedia] : [];
    const temp = sm ? sm : [];
    const index = temp.findIndex((item: any) => item.Platform === platformType);
    if (index >= 0) temp[index].Link = event.target.value;
    else {
      temp.push({
        Platform: platformType,
        Link: event.target.value,
      });
    }
    setSocialMedia(temp);
  };

  const handleSubmit = () => {
    switch (editType) {
      case "Name":
        dispatch(handleSubmitBasicInfo("Name"));

        break;
      case "Slogan":
        dispatch(handleSubmitBasicInfo("Slogan"));

        break;
      case "BrandColour":
        dispatch(handleSubmitBasicInfo("BrandColour"));

        break;
      case "Address":
        dispatch(handleSubmitAddress());

        break;
      case "Returns":
        dispatch(handleSubmitReturnsWindow());

        break;
      case "Facebook":
        dispatch(handleSubmitSocialMedia());

        break;
      case "Youtube":
        dispatch(handleSubmitSocialMedia());

        break;
      case "Instagram":
        dispatch(handleSubmitSocialMedia());

        break;
      case "Linkedin":
        dispatch(handleSubmitSocialMedia());

        break;
      case "Twitter":
        dispatch(handleSubmitSocialMedia());

        break;
      default: {
        setEditModalOpen(false);
      }
    }
    //dispatch(getAccountDetails());
    setEditModalOpen(false);
  };

  const handleSubmitBasicInfo = (infoType: string) => {
    const body = {
      Name: data?.Name,
      Slogan: data?.Slogan,
      BrandColour: data?.BrandColour,
    };
    if (infoType === "Name") {
      body.Name = merchantName;
      setMerchantName("");
    } else if (infoType === "Slogan") {
      body.Slogan = slogan;
      setSlogan("");
    } else {
      body.BrandColour = brandColour;
      setBrandColour("");
    }
    return (dispatch: any) => {
      HttpRegularPut("/merchant/basic-info", body, {
        dispatch,
        actionSuccess: getAccountDetails,
        // actionFailure: () => setError("Could not update!"),
      });
    };
  };

  const handleSubmitAddress = () => {
    return (dispatch: any) =>
      HttpRegularPut(
        "/merchant/address",
        { ...address, Line3: "" },
        {
          dispatch: dispatch,
          actionSuccess: getAccountDetails,
          // actionFailure: () => setError("Could not update!"),
          callback: () => setAddress({}),
        }
      );
  };

  const handleSubmitReturnsWindow = () => {
    return (dispatch: any) =>
      HttpRegularPut(
        "/merchant/returns-policy",
        {
          Policy: data?.ReturnsPolicy?.Policy,
          ReturnsWindow: returnsWindow,
        },
        {
          dispatch: dispatch,
          actionSuccess: getAccountDetails,
          // actionFailure: () => setError("Could not update!"),
          callback: () => setReturnsWindow(null),
        }
      );
  };

  const handleSubmitImage = (image: any) => {
    setImageLoading(true);
    const data = new FormData();
    data.append("file", image);
    return (dispatch: any) =>
      HttpRegularPost("/merchant/logo", data, {
        dispatch: dispatch,
        actionSuccess: getAccountDetails,
        actionFailure: () => {},
        callback: () => {
          if (roleName() === "Merchant") {
            dispatch(getAccountDetails());
            setImageLoading(false);
          }
        },
      });
  };

  const handleSubmitSocialMedia = () => {
    return (dispatch: any) =>
      HttpRegularPut(
        "/merchant/social-media",
        {
          MerchantSocialMediaLinks: socialMedia,
        },
        {
          dispatch: dispatch,
          actionSuccess: getAccountDetails,
          // actionFailure: () => setError("Could not update!"),
          callback: () => setSocialMedia(null),
        }
      );
  };

  const getReturnWindowText = (returnWindow: any) => {
    if (returnWindow === undefined) {
      return "Add return window";
    }
    return data?.ReturnsPolicy?.ReturnsWindow + " calendar days";
  };

  const socialMediaLinks = () => {
    if (data?.MerchantSocialMediaLinks) {
      return Platforms.map((platform: string, index: number) => {
        const result = data?.MerchantSocialMediaLinks.filter(
          (item) => item.Platform === platform
        );
        if (result.length > 0) {
          const item = result[0];
          return (
            <InfoLine
              key={index}
              name={item?.Platform ?? ""}
              value={item?.Link ? item.Link : "Add link"}
              onClick={() => {
                setEditType(item?.Platform);
                setModalTitle(item?.Platform);
                setEditModalOpen(true);
              }}
              clickable
              hasBorder={index !== Platforms.length - 1}
            >
              <InfoLine.ArrowArea></InfoLine.ArrowArea>
            </InfoLine>
          );
        } else {
          return (
            <InfoLine
              key={index}
              name={platform}
              value={"Add link"}
              onClick={() => {
                setEditType(platform);
                setModalTitle(platform);
                setEditModalOpen(true);
              }}
              clickable
              hasBorder={index !== Platforms.length - 1}
            >
              <InfoLine.ArrowArea></InfoLine.ArrowArea>
            </InfoLine>
          );
        }
      });
    }
    return <></>;
  };

  return (
    <Box className={classes.container}>
      <CssBaseline />

      <Container className={classes.root}>
        <HeaderWithButtonsResponsive title="Account Settings" />
        {/** alse || shopDetailsLoading || data.length === 0 ? */}
        {is_able_to("view_detailed_account_settings") && (
          <>
            <Container className={classes.detailsContainer}>
              <InfoBox title="Basic Information">
                <div
                  className={`${classes.uMarginBottom8} ${classes.uMarginTop12}`}
                >
                  <Typography
                    display="block"
                    variant="body2"
                    component="p"
                    color="textSecondary"
                  >
                    This information will be visible to the TradeKart customers.
                  </Typography>
                </div>
                <Grid container className={classes.infoTextContainer}>
                  <Grid item xs={3}>
                    <Typography
                      display="inline"
                      variant="caption"
                      component="span"
                      color="textSecondary"
                    >
                      LOGOTYPE
                    </Typography>
                  </Grid>
                  <Grid item xs={8} className={classes.colOffset}>
                    <Typography
                      variant="body2"
                      component="span"
                      color="textSecondary"
                    >
                      Square image with 512px x 512px resolution transparent
                      background works best
                    </Typography>
                  </Grid>
                  <Grid item container xs={1}>
                    <label
                      style={{
                        width: 60,
                        height: 60,
                        backgroundImage: data?.LogoUrl ? `url("${data.LogoUrl}")` : "",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundColor: "rgba(0, 0, 0, 0.08)",
                        position: "relative",
                        outline: "1px solid rgba(0, 0, 0, 0.08)",
                        borderRadius: 4,
                        cursor: "pointer",
                      }}
                      className="custom-file-upload"
                    >
                      <input
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          if (event.target.files) {
                            const image = event.target.files[0];
                            const extension = image.name.split(".").pop();
                            if (
                              !imageTypes.some((type) => type === extension)
                            ) {
                              setErrorModalOpen(true);
                              return;
                            }
                            dispatch(handleSubmitImage(event.target.files[0]));
                          }
                        }}
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                      />
                      <div
                        style={{
                          backgroundColor: "rgba(0,0,0,0.87)",
                          position: "absolute",
                          bottom: 0,
                          right: 0,
                          left: 0,
                          borderBottomLeftRadius: 4,
                          borderBottomRightRadius: 4,
                          height: "36%",
                          width: "100%",
                          textAlign: "center",
                        }}
                      >
                        <PhotoCameraOutlined
                          htmlColor="rgb(255,255,255)"
                          style={{ width: 20, height: 20 }}
                        />
                      </div>
                      {imageLoading && (
                        <div className={classes.loadingContainer}>
                          <CircularProgress size={24} />
                        </div>
                      )}
                    </label>
                  </Grid>
                </Grid>

                <InfoLine
                  name="MERCHANT NAME"
                  value={data?.Name ? data.Name : "Add merchant"}
                ></InfoLine>
                <InfoLine
                  name="SLOGAN"
                  value={data?.Slogan ? data.Slogan : "Add slogan"}
                  onClick={() => {
                    setModalTitle("Slogan");
                    setSlogan(data?.Slogan ?? "");
                    setEditType("Slogan");
                    setEditModalOpen(true);
                  }}
                  clickable
                >
                  <InfoLine.ArrowArea></InfoLine.ArrowArea>
                </InfoLine>
                <InfoLine
                  name="BRAND COLOUR"
                  value={
                    data?.BrandColour
                      ? "#" + data.BrandColour.replace("+", "")
                      : "Add brand colour"
                  }
                  onClick={() => {
                    setEditType("BrandColour");
                    setBrandColour(data?.BrandColour ?? "");
                    setModalTitle("Brand Colour");
                    setEditModalOpen(true);
                  }}
                  clickable
                  hasBorder={false}
                >
                  <InfoLine.ArrowArea>
                    {data?.BrandColour && (
                      <div
                        style={{
                          position: "relative",
                          left: -8,
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          border: "1px solid rgba(0, 0, 0, 0.08)",
                          backgroundColor:
                            "#" + data.BrandColour.replace("+", ""),
                          cursor: "pointer",
                        }}
                      ></div>
                    )}
                  </InfoLine.ArrowArea>
                </InfoLine>
              </InfoBox>

              <InfoBox title="Head office address">
                <InfoLine
                  name="ADDRESS"
                  value={
                    data?.Address &&
                    addressStringConvertor(
                      data?.Address.Line1,
                      data?.Address.Line2,
                      data?.Address.Line3,
                      data?.Address.City,
                      data?.Address.County,
                      data?.Address.PostalCode
                    )
                  }
                  onClick={() => {
                    setModalTitle("Address");
                    setAddress(data?.Address ?? {});
                    setEditType("Address");
                    setEditModalOpen(true);
                  }}
                  clickable
                  hasBorder={false}
                >
                  <InfoLine.ArrowArea></InfoLine.ArrowArea>
                </InfoLine>
              </InfoBox>

              {/** Return Policiy */}
              <InfoBox title="Return policy">
                <Typography variant="body1" component="p" color="textSecondary">
                  This information will be visible to the TradeKart customers.
                </Typography>
                <InfoLine
                  name="RETURNS WINDOW"
                  value={getReturnWindowText(
                    data?.ReturnsPolicy?.ReturnsWindow
                  )}
                  onClick={() => {
                    setModalTitle("Returns Window");
                    setReturnsWindow(data?.ReturnsPolicy?.ReturnsWindow ?? "");
                    setEditType("Returns");
                    setEditModalOpen(true);
                  }}
                  clickable
                >
                  <InfoLine.ArrowArea></InfoLine.ArrowArea>
                </InfoLine>
                <InfoLine
                  name="POLICY"
                  value={
                    data?.ReturnsPolicy?.Policy
                      ? data.ReturnsPolicy.Policy
                      : "Add policy"
                  }
                  onClick={() => {
                    history.push(
                      "/merchant/privacy-policy/" +
                        (data?.ReturnsPolicy?.ReturnsWindow ?? 1)
                    );
                  }}
                  clickable
                  hasBorder={false}
                >
                  <InfoLine.ArrowArea></InfoLine.ArrowArea>
                </InfoLine>
              </InfoBox>

              {/** Social Media Links */}
              <InfoBox title="Social Media Links">{socialMediaLinks()}</InfoBox>
              <GeneralModal
                visible={editModalOpen}
                title={modalTitle}
                description=""
                onClose={setEditModalOpen}
              >
                <GeneralModal.ContentArea>
                  {editType === "Address" ? (
                    <>
                      <TextField
                        placeholder="Address Line 1"
                        value={address?.Line1}
                        onChange={handleAddressChange("Line1")}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        id="Line1"
                        label="Address line 1"
                        name="Line1"
                        autoFocus
                        InputProps={{
                          classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline,
                          },
                        }}
                      />
                      <TextField
                        placeholder="Address Line 2"
                        value={address?.Line2}
                        onChange={handleAddressChange("Line2")}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        id="Line2"
                        label="Address line 2"
                        name="Line2"
                        autoFocus
                        InputProps={{
                          classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline,
                          },
                        }}
                      />
                      {/********************* */}
                      <Grid container spacing={3}>
                        <Grid item xs={6}>
                          <TextField
                            placeholder="PostalCode"
                            value={address?.PostalCode}
                            onChange={handleAddressChange("PostalCode")}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="PostalCode"
                            label="Post Code"
                            name="PostalCode"
                            autoFocus
                            InputProps={{
                              classes: {
                                root: classes.cssOutlinedInput,
                                focused: classes.cssFocused,
                                notchedOutline: classes.notchedOutline,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            placeholder="City"
                            value={address?.City}
                            onChange={handleAddressChange("City")}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="City"
                            label="City"
                            name="City"
                            autoFocus
                            InputProps={{
                              classes: {
                                root: classes.cssOutlinedInput,
                                focused: classes.cssFocused,
                                notchedOutline: classes.notchedOutline,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                      {/********************* */}
                      <TextField
                        placeholder="County"
                        value={address?.County}
                        onChange={handleAddressChange("County")}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        id="County"
                        label="County"
                        name="County"
                        autoFocus
                        InputProps={{
                          classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline,
                          },
                        }}
                      />
                      <TextField
                        placeholder="United Kingdom"
                        value="United Kingdom"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        id="Country"
                        label="Country"
                        name="Country"
                        disabled
                        autoFocus
                        InputProps={{
                          classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline,
                          },
                        }}
                      />
                    </>
                  ) : editType === "Name" ? (
                    <TextField
                      placeholder="Merchant Name"
                      value={merchantName}
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id="Name"
                      label="Name"
                      name="Name"
                      onChange={(e) => setMerchantName(e.target.value)}
                      autoFocus
                      InputProps={{
                        classes: {
                          root: classes.cssOutlinedInput,
                          focused: classes.cssFocused,
                          notchedOutline: classes.notchedOutline,
                        },
                      }}
                    />
                  ) : editType === "Slogan" ? (
                    <TextField
                      placeholder="Slogan"
                      value={slogan}
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id="Slogan"
                      label="Slogan"
                      name="Slogan"
                      onChange={(e) => setSlogan(e.target.value)}
                      autoFocus
                      InputProps={{
                        classes: {
                          root: classes.cssOutlinedInput,
                          focused: classes.cssFocused,
                          notchedOutline: classes.notchedOutline,
                        },
                      }}
                    />
                  ) : editType === "BrandColour" ? (
                    <div>
                      <Typography variant="body2" component="p">
                        Enter the hex colour code of your brand colour
                      </Typography>
                      <TextField
                        placeholder="Hex colour code"
                        value={brandColour}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        id="BrandColour"
                        label="Brand Colour"
                        name="BrandColour"
                        onChange={(e) => setBrandColour(e.target.value)}
                        autoFocus
                        InputProps={{
                          classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline,
                          },
                        }}
                      />
                    </div>
                  ) : editType === "Returns" ? (
                    <TextField
                      placeholder="Returns Window"
                      value={returnsWindow ?? 0}
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id="Returns"
                      type="number"
                      label="Returns"
                      name="Returns"
                      onChange={(event) =>
                        setReturnsWindow(parseInt(event.target.value))
                      }
                      autoFocus
                      InputProps={{
                        classes: {
                          root: classes.cssOutlinedInput,
                          focused: classes.cssFocused,
                          notchedOutline: classes.notchedOutline,
                        },
                      }}
                    />
                  ) : editType === "Instagram" ||
                    editType === "Facebook" ||
                    editType === "Youtube" ||
                    editType === "Twitter" ||
                    editType === "Linkedin" ? (
                    <TextField
                      placeholder="Link"
                      value={
                        (socialMedia
                          ? socialMedia
                          : data?.MerchantSocialMediaLinks
                          ? data?.MerchantSocialMediaLinks
                          : []
                        ).find((item: any) => item.Platform === editType)?.Link
                      }
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id={editType}
                      label={editType}
                      name={editType}
                      onChange={handleSocialMediaEdit(editType)}
                      autoFocus
                      InputProps={{
                        classes: {
                          root: classes.cssOutlinedInput,
                          focused: classes.cssFocused,
                          notchedOutline: classes.notchedOutline,
                        },
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </GeneralModal.ContentArea>
                <GeneralModal.ButtonArea>
                  <CancelButton onClick={() => setEditModalOpen(false)} />
                  <SubmitButton onClick={handleSubmit} />
                </GeneralModal.ButtonArea>
              </GeneralModal>
              <ErrorModal
                visible={errorModalOpen}
                title="File not supported"
                errorBody="Please upload a valid image file"
                onClose={() => setErrorModalOpen(false)}
              />
            </Container>
          </>
        )}
      </Container>
      {/* <TrigerPrint
        print={print}
        printFunc={PrintLabels}
        printAgain={printAgain}
        printAgainFunc={PrintLabelsAgain}
      />
      <NumberOfPackageSelectionModal
        visible={numberOfPackageModalVisible}
        onClose={() => setNumberOfPackageModalVisible(false)}
        onSubmit={(packages: any) => PackagesSelected(packages)}
      /> */}
    </Box>
  );
};
const useStyles = makeStyles((theme: ITheme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  imageList: {
    display: "flex",
    flexDirection: "row",
    marginTop: 15,
    paddingLeft: 0,
  },
  images: {
    width: 200,
    height: 150,
    marginRight: 10,
  },
  submitButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    "&:hover": {
      backgroundColor: theme.palette.primary[92],
    },
    "&:active": {
      backgroundColor: theme.palette.primary[76],
    },
  },
  cancelButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.secondary.main,
    marginRight: "8px",
    "&:hover": {
      backgroundColor: theme.palette.secondary[16],
    },
    "&:active": {
      backgroundColor: theme.palette.secondary[32],
    },
  },
  cssOutlinedInput: {
    display: "flex",
    "&$cssFocused $notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,

    },
  },

  cssFocused: {},

  notchedOutline: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  printButtonText: {
    textTransform: "none",
  },
  root: {
    maxWidth: "840px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  detailsContainer: {
    marginTop: "24px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  printableSection: {
    display: "none",
  },
  infoTextContainer: {
    alignItems: "center",
    paddingTop: 15,
    paddingBottom: 15,
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
  },
  uMarginBottom8: {
    marginBottom: 8,
  },
  uMarginTop12: {
    marginTop: 12,
  },
  colOffset: {
    marginLeft: -17.5,
    marginRight: 17.5,
  },
  loadingContainer: {
    position: "absolute",
    width: 60,
    height: 60,
    top: 0,
    left: 0,
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
}));
